export default __webpack_public_path__ + "static/media/Marilyn_Oduenyi_AHV_In_Moms_We_Trust.7f65573a.jpg";